import React, { useState, useEffect } from 'react';
import { Star } from 'lucide-react';

const TrustpilotBadge = () => {
  const [rating, setRating] = useState(0);
  const [reviews, setReviews] = useState(0);
  const [starsVisible, setStarsVisible] = useState(0);

  useEffect(() => {
    
    const starTimers = [0, 1, 2, 3, 4].map((i) =>
      setTimeout(() => setStarsVisible(i + 1), 300 + i * 200)
    );

    
    let r = 0;
    const ratingTimer = setInterval(() => {
      r += 0.1;
      if (r >= 4.7) { setRating(4.7); clearInterval(ratingTimer); }
      else setRating(parseFloat(r.toFixed(1)));
    }, 40);

    
    let rv = 0;
    const reviewTimer = setInterval(() => {
      rv += 8;
      if (rv >= 402) { setReviews(402); clearInterval(reviewTimer); }
      else setReviews(Math.floor(rv));
    }, 20);

    return () => {
      starTimers.forEach(clearTimeout);
      clearInterval(ratingTimer);
      clearInterval(reviewTimer);
    };
  }, []);

  return (
    <div className="inline-flex items-center gap-3 bg-[#ffffff04] border border-[#ffffff08] rounded-full px-4 py-2 backdrop-blur-sm trustpilot-badge-wrapper">
            <div className="flex items-center gap-0.5">
        {[0, 1, 2, 3, 4].map((i) => (
          <div
            key={i}
            className="transition-all duration-300"
            style={{
              transform: i < starsVisible ? 'scale(1)' : 'scale(0)',
              opacity: i < starsVisible ? 1 : 0,
              transitionDelay: `${i * 100}ms`
            }}
          >
            <Star
              className="w-4 h-4"
              fill="#00b67a"
              color="#00b67a"
            />
          </div>
        ))}
      </div>

            <div className="w-px h-4 bg-[#ffffff10]"></div>

            <div className="flex items-center gap-2">
        <span className="text-white font-bold text-sm tabular-nums">{rating.toFixed(1)}</span>
        <div className="flex flex-col">
          <span className="text-[#00b67a] text-[10px] font-semibold leading-none">Trustpilot</span>
          <span className="text-[#666] text-[9px] leading-none mt-0.5">{reviews} reviews</span>
        </div>
      </div>

            <div className="trustpilot-shimmer"></div>
    </div>
  );
};

export default TrustpilotBadge;
